import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { remove } from "../../services/upload-files.service";
import { deleteReportsData, start } from "../../store/slices/ReportsSlice";

const ReportsData = ({ searchTerm }) => {
    const loading = useSelector((state) => state.reports.loading);
    const savedReportsData = useSelector((state) => state.reports.data.reportsdata);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleClick = (id, formattedfromdate, formattedtodate) => {
        const route = `/reportsdatadetails`;
        navigate(route, { state: { id, formattedfromdate, formattedtodate } });
    };

    const handleDelete = (id, event) => {
        event.stopPropagation();
        dispatch(start());
        remove(`reports/internal/${id}`).then((res) => {
            if (res.affectedRows > 0) {
                dispatch(deleteReportsData(id));
            }
        });
    };

    // Filter reports data based on search term
    const filteredData = savedReportsData
        ? savedReportsData.filter((report) =>
              report.name.toLowerCase().includes(searchTerm.toLowerCase())
          )
        : [];

    if (loading) {
        return (
            <>
                <main className="col-md-12">
                    <h1 className="h2 py-2"> <i className="fa-solid fa-spinner fa-spin"></i></h1>
                </main>
            </>
        );
    }

    return (
        <>
            {filteredData && filteredData.length > 0 ? (
                filteredData.map((curData) => {
                    const { id, name, created_at, owner, from_date, to_date, status } = curData;
                    const createdat = new Date(created_at);
                    const fromdate = new Date(from_date);
                    const todate = new Date(to_date);

                    const options = { day: 'numeric', month: 'short', year: 'numeric' };
                    const formattedcreatedat = createdat.toLocaleDateString('en-GB', options);
                    const formattedfromdate = fromdate.toLocaleDateString('en-GB', options);
                    const formattedtodate = todate.toLocaleDateString('en-GB', options);

                    return (
                        <tr
                            key={id}
                            onClick={() => handleClick(id, formattedfromdate, formattedtodate)}
                            className="clickable"
                        >
                            <td>{name ? name : "--"}</td>
                            <td style={{paddingLeft:"40px"}}>{formattedcreatedat}</td>
                            <td>{owner}</td>
                            <td style={{paddingRight:"30px"}}>{formattedfromdate} to {formattedtodate}</td>
                            {/*<td style={{paddingLeft:"70px"}}>{status}</td>*/}
                            <td>
                                <button className="custom-button" onClick={(event) => handleDelete(id, event)}>
                                    <i className="fa fa-trash" style={{color:"red"}} aria-hidden="true"></i>
                                </button>
                            </td>
                        </tr>
                    );
                })
            ) : (
                <tr>
                    <td colSpan="6">No data available.</td>
                </tr>
            )}
        </>
    );
};

export default ReportsData;